import { Pipe, PipeTransform } from '@angular/core';
import { enumLengthUnit } from '@data-layer/enums/common';

@Pipe({
  name: 'lengthUnit',
})
export class LengthUnitPipe implements PipeTransform {
  public transform(value: enumLengthUnit): string {
    return 'LENGTH_UNIT.' + enumLengthUnit[value];
  }
}
